import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import isSuperAdminSelector from 'store/selectors/isSuperAdmin';

const SuperAdminGate = ({ component: Component }) => {
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  if (isSuperAdmin) {
    return <Component />;
  }

  return <Navigate replace to="/home/messages" />;
};

export default SuperAdminGate;
